import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=06a361f8&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/pages/notifications/management-notifications.scss?vue&type=style&index=0&id=06a361f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a361f8",
  null
  
)

export default component.exports